import { LaunchDarklyProvider } from "@mma/common";
import React, { FC, useContext, useEffect } from "react";
import Head from "../components/Head";
import Hero from "../components/hero1";
import Layout from "../components/layout1";
import ThirdParty from "../components/thirdParty1";
import { TrustedDevices } from "../components/TrustedDevices/TrustedDevices";
import { consent_management, pathKey } from "../constants/static";
import { StateContext } from "../context/stateContext";
import { authorize } from "../endpoints/authorize";
import useConfig from "../hooks/useConfig";

const Home: FC = () => {

  if (!window.location.pathname.includes(consent_management)) {
    return (
      <div>
        <Head>
          <title>Trusted devices</title>
        </Head>
        <Layout
          desktopLeftMain={<Hero isForTrustedDevices={true} />}
          desktopRightMain={<TrustedDevices />}
          backButton={false}
          onBackBtnClick={() => null}
        />
      </div>
    );
  }
  return (
    <div>
      <Head>
        <title>Consent Management</title>
      </Head>
      <Layout
        desktopLeftMain={<Hero />}
        desktopRightMain={<ThirdParty />}
        backButton={false}
        onBackBtnClick={() => null}
      />
    </div>
  );
};

export default Home;
